module.exports = __webpack_public_path__ + "img/templateTwo.86ad5a6d.png";